@for (linked_record of linked_recordsList; track linked_record) { @if(linked_record | isInlineViewTemplate){
<div class="app__internal--links app__role--players--card mt-3">
  <mat-dialog-content class="mat-dialog-content">
    <mat-accordion class="prevent-click" [@.disabled]="true">
      <mat-expansion-panel
        hideToggle
        [disabled]="true"
        [expanded]="true"
        class="parametersPanel relative shadow-none rounded-t-none rounded-b-none mt-[-10px]"
      >
        <mat-expansion-panel-header class="h-8 disable_ripple">
          <mat-panel-title>
            <div class="app__between--justified--content flex-row w-full">
              <p class="text-base m-0 font-bold text-[#010B18]">
                {{ linked_record.label }}
              </p>
              @if(!hideManageButton){
              <button
                class="app__internal--links--add--btn app__centered-item w-fit leading-[34px]"
                [ngClass]="{
                  'text-[#25508E] hover:cursor-pointer': !isRemoveEditSaveSharing,
                  'text-[#C1C2C5] hover:cursor-default': isRemoveEditSaveSharing
                }"
                [disabled]="isRemoveEditSaveSharing"
                (click)="!isRemoveEditSaveSharing && updateLinkedTemplate(linked_record)"
              >
                <span
                  class="material-icons relative text-[16px]"
                  [ngClass]="{
                    'text-[#25508e]': !isRemoveEditSaveSharing,
                    'text-[#C1C2C5]': isRemoveEditSaveSharing
                  }"
                  >settings</span
                >
                <span class="relative"> Manage </span>
              </button>

              }
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>
        @if (!linked_record.is_running) {
        <div class="mt-[10px]">
          <view-template-list
            #viewTemplateList
            [hideManageButton]="hideManageButton"
            [linked_record]="linked_record"
            [currentuserId]="currentuserId"
            [getLinkedLocation]="linked_record.getLinkedLocation"
            [linkedLocation]="linked_record.linkedLocation"
            [currentFormId]="currentFormId"
            [formsList]="formsList"
            [isRemoveEditSaveSharing]="isRemoveEditSaveSharing"
            [hideCheckbox]="isRemoveEditSaveSharing ? true : false"
            (manageTemplate)="manageTemplate($event)"
            (locationLinkedTemplateSelectionChange)="onLocationLinkedTemplateSelectionChange($event)"
          >
          </view-template-list>
        </div>
        }
      </mat-expansion-panel>
    </mat-accordion>
  </mat-dialog-content>
</div>
}@else {
<div class="app__internal--links app__role--players--card mt-3 p-5">
  @if (!linked_record.is_running) {
  <edit-add-linked-template-popup
    [inlinedata]="processData(linked_record)"
    [inlineComponent]="true"
    [isFromLinkedTemplate]="true"
    [isRemoveEditSaveSharing]="isRemoveEditSaveSharing"
    [hideCheckbox]="isRemoveEditSaveSharing ? true : false"
    (linkedTemplateSelectionChange)="onLocationLinkedTemplateSelectionChange($event)"
  ></edit-add-linked-template-popup>
  }
</div>
} }
